 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		53: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		53: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app/" + ({"1":"Assessments~AssignmentsModalV2~AssignmentsV2~DirectShareWorksheets~KidFrameDetail~MyAssignments~MySt~912a9358","2":"AssignmentsV2~GradeFilteredContentCards~HomeLearning~InteractiveWorksheetsOverview~MyAssignments~MyC~3abcad88","3":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","6":"vendors~Assessments~GoalDetails~MemberHomepage~ProgressTracker","7":"Checkout~Gift~UpdatePayment","8":"LandingPage~Pricing","9":"RegistrationModal","11":"AccountSettings","12":"Assessments","13":"AssignmentsModalV2","14":"AssignmentsV2","15":"BrainzyPaint","16":"Checkout","17":"DirectShareWorksheets","18":"FeaturedArtwork","19":"FillableWorksheet","20":"Gift","21":"GoalDetails","22":"GradeFilteredContentCards","23":"GradeWorksheetModal","24":"HomeLearning","25":"InteractiveWorksheetsOverview","26":"KidFrame","27":"KidFrameDetail","28":"LandingPage","29":"MemberHomepage","30":"MyAssignments","31":"MyCollections","32":"MyStudents","33":"Onboarding","34":"PracticeSkill","35":"PredefinedCollectionsDetail","36":"Pricing","37":"ProgressTracker","38":"RelatedGuidedLesson","39":"Reviews","40":"SeasonalDaysDropdown","41":"Sellpage","42":"SubPlansList","43":"SubmissionsReportPage","44":"SwitchAccountModal","45":"TakeAssessmentModal","46":"TopNav","47":"UpdatePayment","48":"vendors~Gift","49":"vendors~MemberHomepage","50":"vendors~MyStudents","51":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"17eab4fd5b45f60df3ec","1":"a21427356d773a24030c","2":"0eb1678a2902d57d1d56","3":"39bc01698e668317fb36","4":"5b980c6812e8c3c2d3ba","5":"91c178084e1fbbf0a829","6":"85b93c2021cfaa13ff38","7":"ba2fc622f15199bb79b3","8":"c34d1f58e9d4ecd59445","9":"00744a81e48b2554a165","10":"0230651bde593b27990e","11":"2f5681e01a2ec92640cc","12":"87be2d7621d7547edd91","13":"27460bb0513bbf372b16","14":"117a7701f32fcc0c9941","15":"538d451a107dd7b09ec1","16":"87ac1226873a27c9fc62","17":"fc0a31a7c8e0b897370b","18":"395617045fe967071d4f","19":"bad4c4a81bd9900af14e","20":"ed86f9ecff3e06dc2544","21":"f000bc18035bea2a4281","22":"e80183d91b5fbde87f82","23":"ea446f083e6d06a26068","24":"df6d691fe102048c99bd","25":"f5e74f3067ee47b677f1","26":"51284091f936fb7ceb21","27":"41cb1d83068c5e0b71c1","28":"1a59d24f689142790776","29":"241877a2c0d48f0f0f68","30":"b7ccdf27bbf30a5754dc","31":"c097697ff3dd1e8ed70b","32":"9a7da42156114cb31487","33":"a040e7217ea71a8537c1","34":"869fd4534d97d0bc7e8d","35":"8c5656de481c1d2dc0f3","36":"e3a21e53673a9855ebf0","37":"08fdab11773ab37ced51","38":"47270896232494ac20ae","39":"351be560283a4e332d06","40":"d918d79068e6c70beebb","41":"a6ae94b29e39997ce9e9","42":"200eae617ac65ba4be67","43":"cc6ccfca9259ac108dde","44":"64413f74db5f3a7fce9b","45":"245db96db64ebcf55e75","46":"06f5b99d3ddd23f562a5","47":"05be6fd350068ddf058a","48":"cab245b8d94f0bc9c2e1","49":"f5ba857f5ac08dd34cc2","50":"7cc82f2a9c09bde6a6e3","51":"bce8a18b6ce7ecdc9d6d","52":"e2526edd033a211d4166","55":"828731ef8a2c3501c1cd","56":"c7952cf34065d59b5656","57":"7f4e733e64dedb7ae3a9","58":"b75c2b1379bd21636f49"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"7":1,"8":1,"9":1,"11":1,"12":1,"13":1,"14":1,"16":1,"17":1,"18":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"36":1,"37":1,"39":1,"40":1,"41":1,"43":1,"45":1,"46":1,"47":1,"48":1,"55":1,"56":1,"57":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app/" + ({"1":"Assessments~AssignmentsModalV2~AssignmentsV2~DirectShareWorksheets~KidFrameDetail~MyAssignments~MySt~912a9358","2":"AssignmentsV2~GradeFilteredContentCards~HomeLearning~InteractiveWorksheetsOverview~MyAssignments~MyC~3abcad88","3":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","6":"vendors~Assessments~GoalDetails~MemberHomepage~ProgressTracker","7":"Checkout~Gift~UpdatePayment","8":"LandingPage~Pricing","9":"RegistrationModal","11":"AccountSettings","12":"Assessments","13":"AssignmentsModalV2","14":"AssignmentsV2","15":"BrainzyPaint","16":"Checkout","17":"DirectShareWorksheets","18":"FeaturedArtwork","19":"FillableWorksheet","20":"Gift","21":"GoalDetails","22":"GradeFilteredContentCards","23":"GradeWorksheetModal","24":"HomeLearning","25":"InteractiveWorksheetsOverview","26":"KidFrame","27":"KidFrameDetail","28":"LandingPage","29":"MemberHomepage","30":"MyAssignments","31":"MyCollections","32":"MyStudents","33":"Onboarding","34":"PracticeSkill","35":"PredefinedCollectionsDetail","36":"Pricing","37":"ProgressTracker","38":"RelatedGuidedLesson","39":"Reviews","40":"SeasonalDaysDropdown","41":"Sellpage","42":"SubPlansList","43":"SubmissionsReportPage","44":"SwitchAccountModal","45":"TakeAssessmentModal","46":"TopNav","47":"UpdatePayment","48":"vendors~Gift","49":"vendors~MemberHomepage","50":"vendors~MyStudents","51":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"37f3561d020909d6f9dc","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"45d4d2727ad4cf9e9a52","8":"2b436e69b3b155a4a770","9":"c8c1b36a8897db352a6a","10":"31d6cfe0d16ae931b73c","11":"4ad35bb3dca41c2cae0b","12":"ce329e4e4a8ddf1500e7","13":"13a4e7436120b3088257","14":"f523bc1ffa081531b751","15":"31d6cfe0d16ae931b73c","16":"96a6752e29d47e240e93","17":"96f10993de42e552b4f0","18":"d56d9288e4c0c7368f48","19":"31d6cfe0d16ae931b73c","20":"b9f3da8c045ad7a5f7ee","21":"09bedb8b0ceaa8eff29a","22":"cc59a2d5075b55748ffc","23":"78f108ef2a1e16d4d1b4","24":"4c89bea8f7f35505c32a","25":"8d1356e1827dc4463b48","26":"efb1490518191223d63d","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"908acb1c52d88ce74b41","30":"6cb66d503e570e554d74","31":"7437bb58b99b603d32fc","32":"1f64f945f7b833aae61b","33":"f3c4d7315b2cad9c81cd","34":"5491656ee574e8b4a49d","35":"31d6cfe0d16ae931b73c","36":"3a33133d8b4cb1687191","37":"85451f8c42dae0de4f7f","38":"31d6cfe0d16ae931b73c","39":"ba9c0fc38afc58c1902d","40":"495c0b9853cb793a31ee","41":"fed495f6ff9f57243990","42":"31d6cfe0d16ae931b73c","43":"05cfc41a18b80aeac5d7","44":"31d6cfe0d16ae931b73c","45":"bf40f2159a5c06b0446f","46":"ddb24ea7ffcfea2391aa","47":"cb30306a496b38be9101","48":"ca68f8fa1dd9edae64fc","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","55":"d7fbd1904b7d8ac3ae36","56":"c7c112df630d782cdeed","57":"c7c112df630d782cdeed","58":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([400,54]);
 	// run deferred modules when ready
 	return checkDeferredModules();
